module.exports = __webpack_public_path__ + "img/cam-capture-button.ad607950.svg";